/**
 * Reviews & Testimonials Configuration
 * Manages internal testimonials and Google Reviews integration
 * Supports admin filtering and visibility controls
 */

// Internal testimonials (manually curated)
// Each testimonial can be approved/hidden via admin panel
export const testimonials = [
  {
    id: 'test-001',
    name: 'Pieter van Wyk',
    location: 'Stellenbosch',
    rating: 5,
    text: 'Absolutely brilliant service! Moved my daughter\'s stuff from res to her new flat in under 2 hours. The guys were careful with everything.',
    service: 'mini-move',
    date: '2024-12-15',
    verified: true,
    avatar: null,
    approved: true,  // Admin can toggle this
    featured: false  // Admin can feature specific testimonials
  },
  {
    id: 'test-002',
    name: 'Sarah Moyo',
    location: 'Cape Town',
    rating: 5,
    text: 'Used Rocket Van Express for a marketplace pickup. The real-time WhatsApp updates were fantastic - I knew exactly when my items would arrive.',
    service: 'delivery',
    date: '2024-12-20',
    verified: true,
    avatar: null,
    approved: true,
    featured: false
  },
  {
    id: 'test-003',
    name: 'Johan Botha',
    location: 'Somerset West',
    rating: 5,
    text: 'Professional, punctual, and careful. They even helped me carry my new couch up three flights of stairs!',
    service: 'delivery',
    date: '2025-01-05',
    verified: true,
    avatar: null,
    approved: true,
    featured: false
  },
  {
    id: 'test-004',
    name: 'Thandi Ndlovu',
    location: 'Paarl',
    rating: 5,
    text: 'Best delivery service in the Winelands! Used them for my small business and now have a monthly account. Highly recommend!',
    service: 'business',
    date: '2025-01-10',
    verified: true,
    avatar: null,
    approved: true,
    featured: true
  },
  {
    id: 'test-005',
    name: 'Michael Chen',
    location: 'Cape Town CBD',
    rating: 4,
    text: 'Great same-day delivery. My package arrived safely and the driver was very professional. Will use again!',
    service: 'delivery',
    date: '2025-01-15',
    verified: true,
    avatar: null,
    approved: true,
    featured: false
  },
  {
    id: 'test-006',
    name: 'Anele Khumalo',
    location: 'Bellville',
    rating: 5,
    text: 'Moved my entire studio apartment for a fraction of what the big companies quoted. Excellent service!',
    service: 'mini-move',
    date: '2025-01-20',
    verified: true,
    avatar: null,
    approved: true,
    featured: false
  }
];

// Google Reviews placeholder config (requires API key)
export const googleReviewsConfig = {
  placeId: '', // Google Place ID for Rocket Van Express
  apiKey: '', // Google Places API key
  enabled: false // Set to true when configured
};

// Trust statistics
export const trustStats = {
  totalDeliveries: '5,000+',
  happyCustomers: '2,500+',
  avgRating: '4.9',
  responseTime: '<5 min',
  onTimeRate: '98%'
};

// Helper functions - only return approved testimonials for public display
export const getTestimonialsByService = (service, includeUnapproved = false) => {
  let filtered = includeUnapproved ? testimonials : testimonials.filter(t => t.approved !== false);
  if (!service || service === 'all') return filtered;
  return filtered.filter(t => t.service === service);
};

export const getRandomTestimonials = (count = 3, includeUnapproved = false) => {
  const approved = includeUnapproved ? testimonials : testimonials.filter(t => t.approved !== false);
  const shuffled = [...approved].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

export const getFeaturedTestimonials = () => {
  return testimonials.filter(t => t.featured && t.approved !== false);
};

export const getAverageRating = (includeUnapproved = false) => {
  const approved = includeUnapproved ? testimonials : testimonials.filter(t => t.approved !== false);
  if (approved.length === 0) return '0.0';
  const total = approved.reduce((sum, t) => sum + t.rating, 0);
  return (total / approved.length).toFixed(1);
};

export const getTotalReviews = (includeUnapproved = false) => {
  const approved = includeUnapproved ? testimonials : testimonials.filter(t => t.approved !== false);
  return approved.length;
};

export default testimonials;
